import React from 'react';
import { Bar } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    BarElement,
    CategoryScale,
    LinearScale,
    Tooltip,
} from 'chart.js';

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip);

const ProgressBarChart = ({ billablePercent }: { billablePercent: number}) => {
    const percentageValue = isNaN(billablePercent) ? 0 : parseFloat(billablePercent.toFixed(1));
    const nonBillablePercent = 100 - percentageValue;

    const data = {
        labels: [''],
        datasets: [
            {
                label: 'Billable',
                data: [percentageValue],
                backgroundColor: '#0C66E4',
                barThickness: 20,
                borderRadius: {
                    topLeft: 6,
                    bottomLeft: 6,
                    topRight: percentageValue === 100 ? 6 : 0,
                    bottomRight: percentageValue === 100 ? 6 : 0,
                },
                borderSkipped: false,
                stack: 'stack1',
            },
            {
                label: 'Non-Billable',
                data: [nonBillablePercent],
                backgroundColor: '#adb5bd',
                barThickness: 20,
                borderRadius: {
                    topRight: 6,
                    bottomRight: 6,
                    topLeft: nonBillablePercent === 100 ? 6 : 0,
                    bottomLeft: nonBillablePercent === 100 ? 6 : 0,
                },
                borderSkipped: false,
                stack: 'stack1',
            },
        ],
    };

    const options = {
        indexAxis: 'y' as const,
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: { display: false },
            tooltip: {
                callbacks: {
                    label: function (context: any) {
                        return `${context.dataset.label}: ${context.raw.toFixed(1)}%`;
                    },
                },
            },
        },
        scales: {
            x: {
                stacked: true,
                display: false,
                max: 100,
            },
            y: {
                stacked: true,
                display: false,
            },
        },
    };

    return (
        <div style={{ width: '100%', height: '40px', position: 'relative' }}>
            <Bar data={data} options={options} />
        </div>
    );
};


export default ProgressBarChart;
